// frontend/src/api/auth.api.js
import apiClient from './client.js';

export const adminLogin = async ({ email, password }) => {
  const response = await apiClient.post('/auth/admin/login', { email, password });
  return response.data.data;
};

export const vendorLogin = async ({ email, password }) => {
  const response = await apiClient.post('/auth/vendor/login', { email, password });
  return response.data.data;
};

export const partnerLogin = async ({ email, password }) => {
  const response = await apiClient.post('/auth/partner/login', { email, password });
  return response.data.data;
};

export const vendorRegister = async (data) => {
  const response = await apiClient.post('/auth/vendor/register', data);
  return response.data.data;
};

export const refreshToken = async (refreshToken) => {
  const response = await apiClient.post('/auth/refresh', { refreshToken });
  return response.data.data;
};

export const getMe = async () => {
  const response = await apiClient.get('/auth/me');
  return response.data.data;
};

export const forgotPassword = async ({ email, userType }) => {
  const response = await apiClient.post('/auth/forgot-password', { email, userType });
  return response.data.data;
};

export const resetPassword = async ({ token, password, userType }) => {
  const response = await apiClient.post('/auth/reset-password', { token, password, userType });
  return response.data.data;
};
